import request from '@/utils/request'

const base = '/db/assets-info'

// 查询接口
export function pagedQuery(data) {
  return request({
    url: base+'/query',
    method: 'post',
    data
  })
}

// 批量上下架
export function batchChangeState(data) {
  return request({
    url: base+'/batch-change-state',
    method: 'post',
    data
  })
}

// 修改接口
export function batchUpdate(data) {
  return request({
    url: base+'/batch-update',
    method: 'post',
    data
  })
}

// 设备图片上传
export function assetsImgUpload(data) {
  return request({
    url: base+'/assets-img-upload',
    method: 'post',
    data
  })
}

export function batchAdd(data) {
    return request({
        url: base+'/batch-add',
        method: 'post',
        data
    })
}

export function eqpPageQuery(data) {
    return request({
        url: base+'/eqp-page-query',
        method: 'post',
        data
    })
}

// 获取设备共享导入模板
export function assetsTemplate(data) {
  return request({
    url: base+'/assets-template',
    method: 'get',
    params:data
  })
}


// 获取设备共享导入模板
export function assetsFileInput(data) {
  return request({
    url: base+'/assets-file-input',
    method:'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

